import * as ng from 'angular';

ng.module('e360')
   .directive('limitLength', limitLengthDirective);

export function limitLengthDirective():ng.IDirective {
   return {
      restrict: 'A',
      require: 'ngModel',
      link: limitLengthDirectiveLinkFn
   };
}

function limitLengthDirectiveLinkFn(
   scope:ng.IScope,
   element:JQuery,
   attrs:ng.IAttributes,
   ngModel:ng.INgModelController)
{
   // input/textarea directives automatically trim model value
   // therefore model value length != field content length
   // not ideal for this use case so disable auto-trim
   attrs.$set("ngTrim", "false");

   let maxlength = parseInt(attrs['limitLength'], 10);

   ngModel.$parsers.push((value) => {
      if (value.length > maxlength) {
         value = value.substr(0, maxlength);
         ngModel.$setViewValue(value);
         ngModel.$render();
      }
      return value;
   });
}
